exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".progressHeader__n7a1y {\n  margin-top: var(--uds-space-2);\n  margin-bottom: var(--uds-space-3);\n}\n@media (min-width: 1024px) {\n  .progressHeader__n7a1y {\n    margin-top: var(--uds-space-4);\n    margin-bottom: var(--uds-space-4);\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"progressHeader": "progressHeader__n7a1y"
};